import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import type { Database } from "@copro/api";

type PostCommand = Database["public"]["Tables"]["subject_actions"]["Insert"];

async function postSubjectAction(command: PostCommand) {
  const { data, error } = await apiClient.from("subject_actions")
    .insert(command)
    .select('id')
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function usePostSubjectAction() {

  return useMutation({
    mutationFn: async (command: PostCommand) => postSubjectAction(command),
  });
}
